import { Route, Link, BrowserRouter as Router } from "react-router-dom";
import React, {Component} from 'react';
import {connect} from 'react-redux';
import CardList from '../components/CardList';
import PinterestSearchBox from '../components/PinterestSearchBox';
import Scroll from '../components/Scroll';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Container from 'react-bootstrap/Container';
import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';
import {App, uFirstName, uLastName, uRating, uId, uImage, uIsSignedIn} from '../containers/App';
import { FaSignOutAlt, FaUser, FaUsers, FaPlus } from "react-icons/fa";
import {setSearchField, requestRobots } from '../actions';
import env from "react-dotenv";
import { getSecureItem, setSecureItem, removeSecureItem } from '../utils/encryption'; // ADD THIS

let URL = `${env.API_URL}/p10`;
let BLOCKED_URL = `${env.API_URL}/blocked`;

const mapStateToProps = state => {
  return{
    searchField: state.searchRobots.searchField,
    robots: state.requestRobots.robots,
    ispending: state.requestRobots.ispending,
    error: state.requestRobots.error
  }
}

const mapDispatchToProps = (dispatch) => {
  return{
    onSearchChange: (event) => dispatch(setSearchField(event.target.value)),
    onRequestRobots: () => dispatch(requestRobots())
  }
}

class Main extends Component{
  constructor() {
    super();
    
    // Load saved state from localStorage
    const savedState = this.loadStateFromStorage();
    
    this.state = {
      route: 'signin',
      isSignedIn: savedState.isSignedIn || false,
      updateFlag: false,
      isLoading: true,
      error: null,
      user: savedState.user || {
        id: '',
        first_name: '',
        last_name: '',
        gender: '',
        email: '',
        joined: '',
        profile_image: '',
        rating: '',
        rating_count: '',
        image_key: '',
        reported: '',
        administrator: ''
      },
      robots: savedState.robots || [],
      blockedUsers: savedState.blockedUsers || [],
      updatedFiltered: savedState.updatedFiltered || [],
    }
    this.setStateApp = this.setStateApp.bind(this);
  }

  // Load state from localStorage with encryption
  loadStateFromStorage() {
    try {
      const savedState = getSecureItem('p10-main-state');
      if (savedState) {
        if (!Array.isArray(savedState.robots)) {
          savedState.robots = [];
        }
        if (!Array.isArray(savedState.updatedFiltered)) {
          savedState.updatedFiltered = [];
        }
        return savedState;
      }
    } catch (error) {
      console.error('Error loading state from storage:', error);
      // Clear corrupted data
      removeSecureItem('p10-main-state');
    }
    return { robots: [], updatedFiltered: [] };
  }

  // Save state to localStorage with encryption
  saveStateToStorage() {
    try {
      const stateToSave = {
        isSignedIn: this.state.isSignedIn,
        user: this.state.user,
        robots: this.state.robots,
        blockedUsers: this.state.blockedUsers,
        updatedFiltered: this.state.updatedFiltered,
        timestamp: Date.now()
      };
      setSecureItem('p10-main-state', stateToSave);
    } catch (error) {
      console.error('Error saving state to storage:', error);
    }
  }

  async setStateApp() {
    try {
      const response = await fetch(URL, {
        type: 'GET',
        credentials: 'include',
        contentType: 'application/json',
        headers: {Authorization: env.API_KEY}
      });
      
      if (!response.ok) {
        throw new Error('Failed to fetch users');
      }
      
      const users = await response.json();
      const usersArray = Array.isArray(users) ? users : [];
      
      this.setState({
        robots: usersArray,
        error: null
      });
      
      return usersArray;
    } catch (error) {
      console.error('Error fetching users:', error);
      this.setState({ 
        error: 'Failed to load profiles. Please try again.',
        isLoading: false 
      });
    }
  }

  async getBlockedUsers() {
    this.setState({ isLoading: true });
    
    try {
      await this.setStateApp();
      
      const userId = window.uId || uId;
      
      if (!userId) {
        console.error('No user ID available');
        this.setState({ isLoading: false });
        return;
      }
      
      const response = await fetch(BLOCKED_URL, {
        method: 'post',
        credentials: 'include',
        headers: {'Content-Type': 'application/json'}, 
      });
      
      const users = await response.json();
      
      if (users !== "Please sign in") {  
        const blockedUserIds = users.map(user => user.profile_id);
        
        const filteredUsers = this.state.robots.filter(
          robot => !blockedUserIds.includes(robot.id)
        );
        
        this.setState({
          blockedUsers: blockedUserIds,
          updatedFiltered: filteredUsers,
          isLoading: false,
          error: null
        }, () => {
          this.saveStateToStorage();
        });
      } else {
        this.setState({ 
          isLoading: false,
          error: 'Please sign in to continue' 
        });
      }
    } catch (error) {
      console.error('Error fetching blocked users:', error);
      this.setState({ 
        error: 'Failed to load profiles.',
        isLoading: false 
      });
    }
  }

  loadUser = (data) => {
    this.setState({
      user: {
        id: data.id,
        first_name: data.first_name,
        last_name: data.last_name,
        email: data.email,
        gender: data.gender,
        joined: data.joined,
        rating: data.rating,
        rating_count: data.rating_count,
        image_key: data.image_key,
        reported: data.reported,
        administrator: data.administrator
      }
    }, () => {
      this.saveStateToStorage();
    });
  }

  componentDidMount() {
    // Load from localStorage if no data
    try {
      const savedState = getSecureItem('p10-app-state');
      
      if (savedState) {
        if (savedState.user && savedState.user.id) {
          window.uFirstName = savedState.user.first_name;
          window.uLastName = savedState.user.last_name;
          window.uRating = savedState.user.rating;
          window.uId = savedState.user.id;
          window.uRatingCount = savedState.user.rating_count;
          window.uImageKey = savedState.user.image_key;
          window.uAdministrator = savedState.user.administrator;
          window.uGender = savedState.user.gender;
          window.uEmail = savedState.user.email;
          window.uJoined = savedState.user.joined;
          window.uProfileImage = savedState.user.profile_image;
          window.uIsSignedIn = true;
          
          this.forceUpdate();
        }
      }
    } catch (error) {
      console.error('Error loading state:', error);
    }
    
    this.getBlockedUsers();
    this.setState({ updateFlag: true });
  }

  componentDidUpdate(prevProps, prevState) {
    // Save state whenever important data changes
    if (JSON.stringify(prevState.updatedFiltered) !== JSON.stringify(this.state.updatedFiltered)) {
      this.saveStateToStorage();
    }

    if (prevState.updateFlag !== this.state.updateFlag && this.state.updateFlag === true) {
      this.getBlockedUsers();
      this.setState({ updateFlag: false });
    }
  }

  onRouteChange = (route) => {
    if (route === 'signout') {
      this.setState({isSignedIn: false});
      removeSecureItem('p10-main-state');
    } else if (route === 'home') {
      this.setState({isSignedIn: true, updateFlag: true});
    }
    this.setState({route: route});
  }

  refreshProfilesAfterAction = () => {
    console.log('refreshProfilesAfterAction: Refreshing profiles');
    this.getBlockedUsers();
  }
  
  render(){
    const { isSignedIn, route, isLoading, error, user } = this.state;
    const { searchField, onSearchChange, isPending } = this.props;
    
    const robotsArray = Array.isArray(this.state.updatedFiltered) ? this.state.updatedFiltered : [];
    
    // FIXED: Search across both first name, last name, and full name
    const filteredRobots = robotsArray.filter(robot => {
      if (!robot) return false;
      
      const searchLower = searchField.toLowerCase();
      const firstName = (robot.first_name || '').toLowerCase();
      const lastName = (robot.last_name || '').toLowerCase();
      const fullName = `${firstName} ${lastName}`.trim();
      
      // Search in first name, last name, or full name
      return firstName.includes(searchLower) || 
             lastName.includes(searchLower) || 
             fullName.includes(searchLower);
    });

    return (
      <div style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
        {/* Modern Top Navigation */}
        <Navbar expand="lg" fixed="top" bg="white" variant="light" style={{ boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
          <Container fluid style={{ maxWidth: '1800px' }}>
            <Navbar.Brand href="/home" style={{ display: 'flex', alignItems: 'center', marginRight: '20px' }}>
              <img src="/images/p10.jpg" alt="P10" style={{ height: '32px', width: '32px', marginRight: '8px',borderRadius: '8px' }}/>
              <span style={{ fontWeight: '600', fontSize: '1.2rem', color: '#1f2937' }}>P10 Rating</span>
            </Navbar.Brand>
            
            <div style={{ 
              flex: '1', 
              maxWidth: '900px', 
              margin: '0 20px',
              display: window.innerWidth < 992 ? 'none' : 'block'
            }}>
              <PinterestSearchBox searchChange={onSearchChange} searchField={searchField} placeholder="Search profiles by name..."/>
            </div>
            
            <Navbar.Toggle aria-controls="main-navbar" />
            <Navbar.Collapse id="main-navbar">
              <div style={{ 
                display: window.innerWidth >= 992 ? 'none' : 'block',
                padding: '10px 0'
              }}>
                <PinterestSearchBox searchChange={onSearchChange} searchField={searchField} placeholder="Search profiles by name..."/>
              </div>
              
              <Nav className="ms-auto">
                <Link to={'/profile'} className="nav-link" style={{ fontWeight: '600' }} onClick={() => this.props.clearSearchField()}>
                  <FaUser style={{ marginRight: '6px' }}/> Profile
                </Link>
                <Link to={'/dimes'} className="nav-link" style={{ fontWeight: '600' }} onClick={() => this.props.clearSearchField()}>
                  <FaUsers style={{ marginRight: '6px' }}/> Dimes
                </Link>
                <Link to={'/userdimes'} className="nav-link" style={{ fontWeight: '600' }} onClick={() => this.props.clearSearchField()}>
                  <FaUsers style={{ marginRight: '6px' }}/> User Dimes
                </Link>
                <Link to={'/addDime'} className="nav-link" style={{ fontWeight: '600' }} onClick={() => this.props.clearSearchField()}>
                  <FaPlus style={{ marginRight: '6px' }}/> Add Dimes
                </Link>
                <Link to={'/signin'} className="nav-link" style={{ fontWeight: '600', color: '#e60023' }}>
                  <FaSignOutAlt style={{ marginRight: '6px' }}/> Log out
                </Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>

        {/* Main Content */}
        <Container fluid style={{ paddingTop: '100px', paddingBottom: '100px', maxWidth: '1400px' }}>
          <div className="tc">
            {/* Welcome Message */}
            {user.first_name && (
              <h1 style={{ fontSize: '2.5rem', fontWeight: '700', color: '#1f2937', marginBottom: '10px' }}>
                Welcome, {user.first_name}!
              </h1>
            )}
            <h2 style={{ fontSize: '1.5rem', color: '#6b7280', marginBottom: '40px' }}>
              Discover and Rate Profiles
            </h2>
            
            {/* Error Alert */}
            {error && (
              <Alert variant="danger" dismissible onClose={() => this.setState({ error: null })}>
                {error}
              </Alert>
            )}
            
            {/* Loading Spinner */}
            {isLoading ? (
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
                <Spinner animation="border" role="status" variant="primary">
                  <span className="sr-only">Loading...</span>
                </Spinner>
              </div>
            ) : (
              <>
                
                {/* No Results Message */}
                {filteredRobots.length === 0 && !isLoading && (
                  <div style={{ textAlign: 'center', padding: '80px 20px' }}>
                    <h2 style={{ color: '#6b7280', marginBottom: '10px' }}>No profiles found</h2>
                    <p style={{ color: '#9ca3af' }}>Try adjusting your search or refresh the page</p>
                  </div>
                )}
                
                {/* Grid Layout - No Overlapping */}
                {filteredRobots.length > 0 && (
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
                    gap: '24px',
                    padding: '20px'
                  }}>
                    {filteredRobots.map((robot, index) => (
                      <div key={index}>
                        <CardList 
                          setTest={() => {}} 
                          robots={[robot]}
                          onRatingSubmitted={this.refreshProfilesAfterAction}
                        />
                      </div>
                    ))}
                  </div>
                )}
              </>
            )}
          </div>
        </Container>

        {/* Modern Footer */}
        <div style={{ 
          backgroundColor: 'white',
          borderTop: '1px solid #e5e7eb',
          padding: '20px 0',
          position: 'fixed',
          bottom: 0,
          width: '100%',
          boxShadow: '0 -2px 4px rgba(0,0,0,0.05)'
        }}>
          <Container>
            <div style={{ 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center',
              flexWrap: 'wrap',
              gap: '20px',
              fontSize: '0.9rem'
            }}>
              <span style={{ color: '#6b7280' }}>© 2026 p10rating</span>
              <Link to="/privacypolicy" style={{ color: '#3b82f6', textDecoration: 'none' }}>Privacy</Link>
              <Link to="/disclaimer" style={{ color: '#3b82f6', textDecoration: 'none' }}>Disclaimer</Link>
              <Link to="/terms" style={{ color: '#3b82f6', textDecoration: 'none' }}>Terms</Link>
            </div>
          </Container>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Main);